import { Playground } from 'docz';
import { Filters } from "../../../../../src/components/Elements";
import Icons from "../../../../../src/components/Icons";
import * as React from 'react';
export default {
  Playground,
  Filters,
  Icons,
  React
};